import { FormattedMessage } from 'react-intl';

import { Sport } from '__generated__/globalTypes';
import { Button } from 'atoms/buttons/Button';
import { ANY_SPORT_MARKET_WHEEL } from 'constants/__generated__/routes';
import { useFeatureFlags } from 'hooks/useFeatureFlags';
import { generateSportPath } from 'lib/routing/generateSportPath';

type Props = {
  nbTickets?: number;
  children?: React.ReactNode;
  sport?: Sport;
  onClick?: () => void;
};

export const SecondaryOrTickets = ({
  nbTickets = 2,
  sport,
  children,
  onClick,
}: Props): React.ReactNode => {
  const {
    flags: {
      marketDailyWheelBySportAndRarity = {
        baseball: { limited: false, common: false },
        football: { limited: false, common: false },
        nba: { limited: false, common: false },
      },
    },
  } = useFeatureFlags();
  if (
    !sport ||
    !marketDailyWheelBySportAndRarity[sport.toLowerCase()]?.limited
  ) {
    return children;
  }

  return (
    <Button
      to={generateSportPath(ANY_SPORT_MARKET_WHEEL, { sport })}
      color="transparent"
      fullWidth
      size="medium"
      onClick={onClick}
    >
      <FormattedMessage
        id="Wheel.Cta.GoSpinNow"
        defaultMessage="{nbTickets, plural, one {+1 Wheel Ticket!} other {+# Wheel Tickets!}} Go Spin Now!"
        values={{
          nbTickets,
        }}
      />
    </Button>
  );
};
